export type ConsentSignal = 'granted' | 'denied';

export interface GoogleConsentSignals {
    ad_storage: ConsentSignal;
    ad_user_data: ConsentSignal;
    ad_personalization: ConsentSignal;
    analytics_storage: ConsentSignal;
    personalization_storage: ConsentSignal;
    functionality_storage: ConsentSignal;
    security_storage: ConsentSignal;
}

const grant = (granted: boolean): ConsentSignal => (granted ? 'granted' : 'denied');

export const buildConsentUpdate = (categories: readonly string[]): GoogleConsentSignals => {
    const has = (name: string) => categories.includes(name);

    return {
        analytics_storage: grant(has('analytics')),
        ad_storage: grant(has('marketing')),
        ad_user_data: grant(has('marketing')),
        ad_personalization: grant(has('marketing')),
        personalization_storage: grant(has('functional')),
        functionality_storage: 'granted',
        security_storage: 'granted',
    };
};
